import { publish, publishSticky, subscribe, unsubscribe } from '@wh/message-bus';
import { StateType } from '@central-products/interface-session-service';
import { isDeviceNative } from '../../utils/deviceDetection';

export const MY_ACCOUNT_VIEW_QUERY_PARAM = 'myAccountView';

const openLogin = () => {
  publish('wh.common.event.ui.header.login.requested');
};

const openMyAccountPage = (viewUrlParam, myAccountConfig) => {
  if (myAccountConfig.legacyMarketingConsentDeepLinkBehavior && viewUrlParam === 'personalDetailsMarketing') {
    publishSticky('wh.myAccount.command.dropdown.open', { path: '/PersonalDetails/Marketing' });
    return;
  }
  const callback = {
    path: viewUrlParam,
  };
  publishSticky('wh.myAccount.command.dropdown.open', callback);
};

export const myAccountDeepLinksFlow = (myAccountConfig) => {
  if (typeof window === 'undefined' || isDeviceNative()) {
    return;
  }

  const rawUrl = window.location.toString().split('?')[0];
  const urlparams = new URLSearchParams(window.location.search);
  const viewUrlParam = urlparams.get(MY_ACCOUNT_VIEW_QUERY_PARAM);
  if (!viewUrlParam) {
    return;
  }

  const sessionStateGet = subscribe({
    topic: 'wh.common.event.session.state.get',
    callback: ({ data }) => {
      if (data.state === 'NOT_LOGGED_IN') {
        openLogin();
      }
    },
  });

  const stateChangedSubscribeId = subscribe({
    topic: 'wh.common.event.sessionService.state.changed',
    callback: async ({ data }) => {
      if (data.state !== StateType.SESSION_EXISTS) {
        return;
      }
      unsubscribe(sessionStateGet);
      unsubscribe(stateChangedSubscribeId);

      openMyAccountPage(viewUrlParam, myAccountConfig);
      urlparams.delete(MY_ACCOUNT_VIEW_QUERY_PARAM);
      const queryStr = urlparams.toString();
      window.history.pushState(null, '', `${rawUrl}${queryStr ? '?' + queryStr : ''}`);
    },
  });
};
